import {computed, Injectable, signal} from '@angular/core';

const STORAGE_KEY = 'crm26.sidebar';
export const SIDEBAR_WIDTH_OPEN = 232;
export const SIDEBAR_WIDTH_COLLAPSED = 56;
/** Below this window width the sidebar is always collapsed, so the content keeps room. */
const NARROW_QUERY = '(max-width: 767px)';

/**
 * Collapsed state of the sidebar, shared with everything that positions itself next to it.
 * The user's choice is remembered in localStorage.
 */
@Injectable({providedIn: 'root'})
export class SidebarStateService {
    /** What the user chose with "Inklappen"; persisted. */
    readonly collapsedByUser = signal(readStored());
    readonly narrow = signal(matchNarrow()?.matches ?? false);
    readonly collapsed = computed(() => this.collapsedByUser() || this.narrow());
    readonly width = computed(() => this.collapsed() ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_OPEN);

    constructor() {
        matchNarrow()?.addEventListener('change', event => this.narrow.set(event.matches));
    }

    toggle() {
        const collapsed = !this.collapsedByUser();
        this.collapsedByUser.set(collapsed);
        try {
            localStorage.setItem(STORAGE_KEY, collapsed ? 'collapsed' : 'open');
        } catch {
            // Storage unavailable: the choice only lasts for this page load
        }
    }
}

function readStored(): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'collapsed';
    } catch {
        return false;
    }
}

function matchNarrow(): MediaQueryList | null {
    return typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(NARROW_QUERY) : null;
}
